import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-update-modal',
  templateUrl: './update-modal.component.html',
  styleUrls: ['./update-modal.component.css']
})
export class UpdateModalComponent {
  statuses: string[] = [
    'Denuncia ingresada',
    'En etapa de investigación',
    'Cierre de la investigación',
    'Análisis del proceso investigativo',
    'Remisión de antecedentes a la Dirección del trabajo',
    'En espera de la resolución de la Dirección del trabajo',
    'Cierre del proceso'];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
    ) {}
}
